export const isLocal = location.hostname == 'localhost'
export const isDev = isLocal || location.hostname.endsWith('preview.dp-core.com')
export const isProd = !isDev
export const routerRootUrl = isLocal ? '/' : '/rct'
